import { ChangeDetectionStrategy, Component, inject, Renderer2 } from '@angular/core';
import { BasketFreeDeliveryNoticeComponentDef } from '@df/basket/free-shipping/basket-free-delivery-notice.component.def';

@Component({
    selector: 'basket-free-shipping',
    templateUrl: 'basket-free-shipping.html',
    styleUrls: ['basket-free-shipping.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketFreeDeliveryNoticeComponent extends BasketFreeDeliveryNoticeComponentDef {
    /**
     * Renderer service
     */
    private renderer2 = inject(Renderer2);

    /**
     * Only make element visible when any rules apply
     */
    override detectChanges(): void {
        super.detectChanges();
        !(this.rules?.length || 0 > 0)
            ? this.renderer2.addClass(this.elementRef.nativeElement, 'ng-hide')
            : this.renderer2.removeClass(this.elementRef.nativeElement, 'ng-hide');
    }
}
